import { toast } from "sonner";
import { updateTicket } from "./api";
import { useMutation } from "@tanstack/react-query";
import { queryClient } from "utils/react-query";

function buildPayload(values) {
    const payload = {};
    if ("attachments" in values) {
        payload.attachments = values.attachments;
    }

    Object.entries(values).forEach(([key, value]) => {
        if (
            !["attachments"].includes(key)
        ) {
            payload[key] = value;
        }
    });

    return payload;
}

export function useUpdateTicket() {
    return useMutation({
        mutationFn: async ({ ticketId, values }) => {
            const payload = buildPayload(values);

            const response = await updateTicket({ ticketId, item: payload });
            return response;
        },
        onSuccess: () => {
            toast.success("Ticket Updated Successfully");
            queryClient.invalidateQueries();
        },
        onError: (error) => {
            toast.error(error.message);
            console.log(error.message);
        },
    });
}
